import type { ReactNode } from 'react';

export const symbol_contact_phone: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M690-479q0-26 3.5-47t12.5-47h54q8 0 14-3.5t11-9.5l33-47q6-9 5.5-20t-8.5-19l-38-37q-9-9-21-8.5t-21 8.5q-47 46-71 105t-24 125q0 66 24 125t71 105q9 8 21 8.5t21-8.5l38-37q8-8 8.5-19t-5.5-20l-33-47q-5-6-11-9.5t-14-3.5h-54q-9-25-12.5-46.5T690-479ZM60-120q-24 0-42-18T0-180v-600q0-24 18-42t42-18h840q24 0 42 18t18 42v600q0 24-18 42t-42 18H60Zm531-60h309v-600H60v600h7q44-69 112.5-109T329-329q81 0 149.5 40T591-180ZM414-435q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35ZM143-180h372q-36-42-84.5-65.5T329-269q-53 0-101.5 23.5T143-180Zm143-297q-17-17-17-43t17-43q17-17 43-17t43 17q17 17 17 43t-17 43q-17 17-43 17t-43-17Zm194-3Z"
		/>
	</svg>
);
